import { useMatch } from 'react-router-dom';

/**
 * Custom hook that extracts pathname from a URL and checks if it matches the current route.
 * useMatch only works with pathname patterns, not full URLs with search params.
 */
export function usePathnameMatch(to: string) {
  const pathname = to.split('?')[0] || to;
  const match = useMatch(pathname);

  return match;
}
